<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #193D6E;">{{ texts.conversions.title }}</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;"> {{ texts.conversions.description }}</div>
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-card v-if="!loading" style="border: 1px solid #c5cdd3; border-radius: 22px;" width="348" elevation="8" outlined>
            <v-card-text class="pt-6">
              <v-row align="center">
                <v-col cols="9">
                  <div class="usd-balance">{{ texts.dashboard.mxnBalance }}</div>
                  <div class="content-balance pt-3">
                    ${{ formatMoney(balanceMxn ? balanceMxn : 0) }} MXN
                  </div>
                </v-col>
                <v-col cols="3" class="d-flex justify-end">
                  <v-img
                    style="border-radius: 10px"
                    src="../../assets/images/Flags_mex.svg"
                    alt="mex-flag"
                    max-width="47"
                    height="35"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0" style="font-family: 'montserrat-semibold'; font-size: 16px;">
                  {{ texts.conversions.assigned + ": " }}
                  <span>${{ formatMoney(balanceMxn ? balanceMxn - avaibleAmount : 0) }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0" style="font-family: 'montserrat-semibold'; font-size: 16px;">
                  {{ texts.conversions.avaible + ": " }}
                  <span>${{ formatMoney(avaibleAmount ? avaibleAmount : 0) }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0 pb-4 d-flex justify-end">
                  <v-btn
                    color="#0075B8"
                    elevation="8"
                    style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="getSuppliers(), dialogSendPay = true;"
                  >
                    <v-icon left dark color="#0075B8"
                      >mdi-arrow-top-right-thin</v-icon
                    >
                    <span class="buttonAddFounds">{{ texts.dashboard.sendPay }}</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="start" align="center" class="d-flex ma-0 mb-4">
        <v-col class="pa-0 my-4">
          <div style="min-width: 200px; max-width: 288px">
            <v-text-field v-model="search" label="Buscar" hide-details style="font-family: 'montserrat-medium'; border-radius: 20px; background-color: white;" append-icon="mdi-magnify" outlined></v-text-field>          
          </div>
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-btn color="#0075B8" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #0075BB; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSX()">
            <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ texts.suppliers.download }}
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table :search="search" v-model="selected" show-select single-select :headers="headersForex" hide-default-header :items="items" class="mb-4 d-none d-sm-block">
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">{{ texts.conversions.id }}</th>
              <th class="header__title center">{{ texts.conversions.transactionDate }}</th>
              <th class="header__title center">{{ texts.conversions.typeTransaction }}</th>                                                                                                                                                                                                                          
              <th class="header__title center">{{ texts.conversions.totalAmountUSD }}</th>
              <th class="header__title center">{{ texts.conversions.totalAmountMXN }}</th>
              <th class="header__title center">{{ texts.conversions.exchangeRate }}</th>
              <th class="header__title right">{{ texts.conversions.actions }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.iTrackingId }}</td>
              <td class="table__item">{{ formatDate(item.created_at) }}</td>
              <td class="table__item">
                <v-chip v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                  {{ "Forward" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                  {{ "Forex" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                  {{ "Window spot" }}
                </v-chip>
                <h4 v-else>
                  {{ "-" }}
                </h4>
              </td>
              <td class="table__item">{{ "$ " + formatMoney(item.dAmount) + " USD" }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.dDesAmount) + " MXN" }}</td>
              <td class="table__item">{{  "$ " + formatMoney(item.dExchangeRate) + " MXN" }}</td>
              <td class="table__item">
                <v-btn color="#0075B8" elevation="3" style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;" outlined @click="getSuppliers(), dialogSendPay = true, avaibleAmount = item.dDesAmount, sTransactionId = item.sTransactionId">
                  <v-icon left>mdi mdi-file-document-plus-outline</v-icon>
                  {{ texts.conversions.pay }}
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="items">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr class="table__item" style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile">
                <div>{{ texts.conversions.id }}</div>
                <div>{{ item.iTrackingId }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.transactionDate }}</div>
                <div>{{ formatDate(item.created_at) }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.typeTransaction }}</div>
                <div>
                  <v-chip v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                    {{ "Forward" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                    {{ "Forex" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                    {{ "Window spot" }}
                  </v-chip>
                  <h4 v-else>
                    {{ "-" }}
                  </h4>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.totalAmountUSD }}</div>
                <div>{{  "$ " + formatMoney(item.dAmount) + " USD" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.totalAmountMXN }}</div>
                <div>{{ "$ " + formatMoney(item.dDesAmount) + " MXN" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.conversions.exchangeRate }}</div>
                <div>{{  "$ " + formatMoney(item.dExchangeRate) + " MXN" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.suppliers.actions }}</div>
                <div>
                  <v-btn color="#0075B8" elevation="3" style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;" outlined @click="getSuppliers(), dialogSendPay = true, avaibleAmount = item.dDesAmount, sTransactionId = item.sTransactionId">
                    <v-icon left>mdi mdi-file-document-plus-outline</v-icon>
                    {{ texts.conversions.pay }}
                  </v-btn>
                </div>
              </td>
            </tr>
            <v-divider></v-divider>
          </tbody>
        </template>
      </v-data-table>
    </v-container>

    <v-dialog v-if="dialogSendPay" v-model="dialogSendPay" persistent width="fit-content" class="pa-8">
      <v-card>
        <v-stepper v-model="e1" alt-labels elevation="0">
          <v-stepper-header v-if="e1 < 4" color="#193D6E" class="mt-5 mr-15 ml-15" elevation="0" 
            style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;"
          >
            <v-stepper-step :complete="e1 > 1" step="1" color="#193D6E"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="#193D6E"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 3" step="3" color="#193D6E"></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" elevation="0" class="pt-0">
              <v-container>
                <v-card style="box-shadow: none !important;"> 
                  <v-card-title style="display: flex; text-align: center; justify-content: center">
                    <span class="title font-weight-bold text-textblack">
                      {{ texts.dashboard.sendPayDetail }}
                    </span>
                  </v-card-title>
                  <v-card-text class="py-0">
                    <div class="mb-4">
                      <v-list rounded v-if="!isLoadingSuppliers">
                        <v-autocomplete
                          :items="suppliers"
                          filled
                          label="Contactos"
                          item-text="sNameAC"
                          return-object
                          v-model="contact"
                          @change="supplier = contact"
                          rounded
                        ></v-autocomplete>
                      </v-list>
                      <v-skeleton-loader
                        v-else
                        class="mx-auto"
                        type="image"
                      ></v-skeleton-loader>
                    </div>
                  </v-card-text>
                  <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                    <v-btn
                      elevation="4"
                      class="mr-2 px-10"
                      style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                      outlined
                      :disabled="loading"
                      @click="dialogSendPay = false, avaibleAmount = avaibleAmountAux, sTransactionId = null"
                    >
                      {{ texts.modalForm.cancel }}
                    </v-btn>
                    <v-btn
                      color="#0075B8"
                      elevation="4343"
                      class="white--text px-10"
                      style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                      :loading="loading"
                      :disabled="contact == null"
                      @click="e1 = 2"
                    > 
                      {{ texts.modalForm.continue }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2" class="pt-0">
              <v-container>
                <v-card style="box-shadow: none !important;">
                  <v-card-title class="pt-0" style="display: flex; justify-content: center; font-family: 'montserrat-bold'; font-size: 24px; color: #2E404E;">
                    {{ texts.dashboard.transferMoney }}
                  </v-card-title>
                  <v-card-text class="info-card">
                    <div class="text-center mb-12">
                      <div class="pa-3 mt-2" outlined style="display: flex; justify-content: space-between; background-color: #F2F2F2; border-radius: 10px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.45);">
                        <div style="text-align: start;">
                          <div class="subtitle-1 font-weight-bold text-textblack">
                            {{ "Cliente:" }}
                          </div>
                          <h2 class="text-h5 font-weight-bold text-center">
                            {{ supplier.sName }}
                          </h2>
                        </div>
                        <div style="text-align: end;">
                          <div class="subtitle-1 font-weight-bold text-textblack">
                            {{ "Saldo de la cuenta:" }}
                          </div>
                          <h2 class="text-h5 font-weight-bold text-center">
                            ${{ formatMoney(avaibleAmount) }} {{ selectedCurrency }}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div class="my-6">
                      <v-text-field
                        outlined
                        :label="`A ${currencyMap[supplier.sAccountCurrency]?.name}`"
                        type="number"
                        dense
                        hide-details
                        :disabled="selectedCurrency != (supplier.sAccountCurrency) ? isLoadingRate : false"
                        v-model="amounts[supplier.sAccountCurrency]"
                        @change="selectedCurrency != (supplier.sAccountCurrency) ? (calculatorAmount(amounts[supplier.sAccountCurrency], true, selectedCurrency, supplier.sAccountCurrency)) : null"
                        prefix="$"
                        class="mb-5"
                      >
                        <template v-slot:append>
                          <div class="d-flex align-center">
                            <img
                              :src="currencyMap[supplier.sAccountCurrency]?.flag"
                              width="24"
                              height="24"
                              alt=""
                              class="rounded"
                            />
                            <h4 class="ml-2 font-weight-bold">{{ supplier.sAccountCurrency }}</h4>
                          </div>
                        </template>
                      </v-text-field>
                    </div>
                    <div v-if="selectedCurrency === (supplier.sAccountCurrency) && selectedCurrency == 'USD'" class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
                      <div class="mr-4" style="border-right: #0075B8 solid 4px; height: 35px"></div>
                      <div style="display: flex; flex-direction: column;">
                        <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E;">
                          Al realizar un pago de USD a USD se aplicará un fee de $12.50 USD.
                        </div>
                      </div>
                    </div>

                    <v-row class="align-center mt-5 mb-4">
                      <v-col class="pb-0">
                        <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                          {{ selectedCurrency == (supplier.sAccountCurrency) ? "Cantidad a enviar" : texts.dashboard.totalConverted  }}
                        </div>
                      </v-col>
                      <v-col class="pb-0 d-flex justify-end">
                        <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px;">
                          ${{ amounts[supplier.sAccountCurrency] ? formatMoney(amounts[supplier.sAccountCurrency]) : 0 }} {{ supplier.sAccountCurrency }}
                        </h2>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                    <v-btn
                      elevation="4"
                      class="mr-2 px-10"
                      style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                      outlined
                      :disabled="loading"
                      @click="e1 = 1"
                    >
                      {{ texts.modalForm.return }}
                    </v-btn>
                    <v-btn
                      color="#0075B8"
                      elevation="4343"
                      class="white--text px-10"
                      style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                      :loading="loading"
                      :disabled="!amounts[supplier.sAccountCurrency] || (selectedCurrency != (supplier.sAccountCurrency) ? isLoadingRate : false) || amounts[supplier.sAccountCurrency] == 0 || amounts[selectedCurrency] == 0 || parseFloat(amounts[supplier.sAccountCurrency]) > parseFloat(avaibleAmount)"
                      @click="e1 = 3, comment = ''"
                    > 
                      {{ texts.modalForm.continue }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="3" class="pt-0">
              <v-container>
                <v-card style="box-shadow: none !important;">
                  <v-card-title class="pt-0" style="display: flex; justify-content: center; font-family: 'montserrat-bold'; font-size: 24px; color: #2E404E;">
                    {{ "Detalle del pago" }}
                  </v-card-title>
                  <v-card-text class="info-card" style="box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.45);">
                    <div class="info-block">
                      <v-textarea
                        class="pa-4"
                        rows="2"
                        :label="texts.dashboard.paymentConcept"
                        v-model="comment"
                        no-resize
                        hide-details
                      ></v-textarea>
                    </div>
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Cliente:</p>
                        <p class="value">{{ supplier?.sName }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;" v-if="supplier.sAccountNumber">
                        <p class="label">Número de cuenta:</p>
                        <p class="value">{{ "*" + (supplier?.accountNumber ? (supplier?.accountNumber).slice(-4) : (supplier?.sAccountNumber).slice(-4)) }}</p>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div class="mb-0" style="display: flex; justify-content: space-between;">
                        <p class="label">Monto destino:</p>
                        <p class="value">{{ "$ " + formatMoney(amounts[supplier.sAccountCurrency]) + " " + (supplier.sAccountCurrency) }}</p>
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                    <v-btn
                      elevation="4"
                      class="mr-2 px-10"
                      style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                      outlined
                      :disabled="loading"
                      @click="e1 = 2, getRate(selectedCurrency, supplier.sAccountCurrency), amounts = { MXN: null, USD: null }"
                    >
                      {{ texts.modalForm.return }}
                    </v-btn>
                    <v-btn
                      color="#0075B8"
                      elevation="4343"
                      class="white--text px-10"
                      style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                      :loading="loading"
                      :disabled="!comment || isLoading"
                      @click="e1 = 4, otp = '', sendVerification()"
                    > 
                      {{ texts.modalForm.continue }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="4" class="pt-0">
              <v-container class="mt-1" style="max-width: 600px;">
                <v-card-title
                  class="pa-0"
                  style="display: flex; text-align: center; justify-content: center"
                >
                  <span class="title font-weight-bold text-textblack">
                    {{ texts.twoFactor.twoFactor }}
                  </span>
                </v-card-title>
                <v-card-text class="py-6 pb-0" v-if="supplier">
                  <div class="pt-4 px-4 mb-4" style="display: flex; justify-content: space-around; flex-direction: row;">
                    <div>
                      <v-otp-input
                        v-model="otp"
                        length="6"
                        type="number"
                        color="#193D6E"
                      ></v-otp-input>
                      <p style="font-size: 14px; font-weight: 500">
                        {{ texts.twoFactor.enterCode }}
                      </p>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: #0075B8; border-radius: 36px; border: 2px solid #0075B8; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    :disabled="loading"
                    @click="e1 = 3"
                  >
                    {{ texts.modalForm.return }}
                  </v-btn>
                  <v-btn
                    color="#0075B8"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    :disabled="otp.length < 6"
                    @click="e1 = 5, sendPayment()"
                  > 
                    {{ texts.modalForm.confirmPay }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="5" class="pt-0">
              <v-btn icon @click="dialogSendPay = false, contact = null, comment = '', amounts = { MXN: null, USD: null }, getConversions(), e1 = 1" :disabled="loadingPayment" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="#2E404E">mdi-close</v-icon>
              </v-btn>
              <v-card class="pa-6 mx-auto">
                <div v-if="loadingPayment" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando pago...</p>
                </div>
                <div v-if="paymentError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193D6E; border-radius: 10px;">
                    {{ "Pago procesado correctamente!" }}
                  </v-card-title>
                </div>
                <div v-if="paymentError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al procesar el pago!
                  </v-card-title>
                </div>
                <v-card-text class="pb-0 px-0" >
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Payment concept:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ comment }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Cliente:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ supplier?.sName }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;" v-if="!supplier">
                        <p class="label">Número de cuenta:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "*" + (supplier?.accountNumber ? (supplier?.accountNumber).slice(-4) : (supplier?.sAccountNumber).slice(-4)) }}</p>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">El destinatario recibira:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[supplier.sAccountCurrency]) + " " + (supplier.sAccountCurrency) }}</p>
                      </div>
                    </div>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export default {
  name: "DashboardView",
  data() {
    return {
      nameXLSX: "ConversionesDisponibles.xlsx",
      texts: "",
      drawer: null,
      dialogEditInvoice: false,
      dialogSendPayOfInvoice: false,
      dialogDetailConversion: false,
      actualCurrency: "0",
      search: "",
      actualCurrencyMxn: "0",
      referenceCurrency: "0",
      isLoading: false,
      otp: "",
      step: 1,
      haveInvoice: false,
      isRegisterEfex: true,
      exchangeRateData: [],
      selectedSupplier: null,
      dialogSendPayMXN: false,
      selectedSupplier: null,
      exchangeRateDataPaid: [],
      exchangeRateDataSeparate: [],
      balanceMxn: "0",
      balanceUsd: "0",
      balance: "0",
      items: [],
      active: false,
      comment: null,
      tab: 0,
      contacts: [],
      step: 0,
      itemsSelected: [],
      isLoadingSuppliers: false,
      totalProfit: "",
      itemsSelectedForwards: [],
      isForwardRateCalculated: false,
      bSelectedAll: false,
      dialogAddFoundss: false,
      dialogSendPay: false,
      dialogAddFounds: false,
      dataAddFounds: {},
      dialogCreate: false,
      amountForexMXN: 0,
      dialogPay: false,
      editableData: {},
      selectedCard: null,
      avaibleAmount: 0,
      today: null,
      totalUsd: 0,
      selectedMenuItem: "dashboard",
      contactData: {
        sName: "",
        sEmail: "",
        sBank_name: "",
        sAccount_number: "",
        sEntity_business: "COMPANY",
      },
      isForwardsActive: false,
      suppliers: [],
      isLoadingInvoices: false,
      showCreateProvider: false,
      isResponsive: false,
      screenWidth: 0,
      bLoading: false,
      isDeferredPayment: false,
      stepper: false,
      e1: 1,
      timerCount: 30,
      rules: {
        required: (v) => !!v || "El campo es obligatorio",
      },
      headersForex: [
        this.selectLanguage === 'en' ? { text: "Id", value: "iTrackingId", align: "center", sortable: false} : { text: "Id", value: "iTrackingId", align: "center", sortable: false},
        this.selectLanguage === 'en' ? { text: "Creation date", value: "created_at", align: "center"} : { text: "Fecha de creación", value: "created_at", align: "center"},
        this.selectLanguage === 'en' ? { text: "Type Transaction", value: "sTransactionType", align: "center"} : { text: "Tipo de transacción", value: "sTransactionType", align: "center"},
        this.selectLanguage === 'en' ? { text: "Total amount USD", value: "dAmount", align: "center"} : { text: "Monto total USD", value: "dAmount", align: "center"},
        this.selectLanguage === 'en' ? { text: "Total amount MXN", value: "dDesAmount", align: "center"} : { text: "Monto total MXN", value: "dDesAmount", align: "center"},
        this.selectLanguage === 'en' ? { text: "Exchange rate", value: "dExchangeRate", align: "center"} : { text: "Tasa de cambio", value: "dExchangeRate", align: "center"},
      ],
      timerId: null,
      dataEfex: {},
      avaibleInvoices: [],
      loading: false,
      exchangeRateAdjustments: [],
      exchangeRatesStateForwards: [],
      isPayMxn: false,
      loadingTransaction: false,
      bSelectedAllSeparate: false,
      dialogEditProfileActive: false,
      isForwards: false,
      isForwardsPayment: false,
      userName: "",
      modalCurrency: 0,
      sections: [
        {
          icon: "mdi mdi-view-dashboard",
          value: "operation",
          title: "Operaciones",
          items: [
            {
              icon: "mdi mdi-view-dashboard",
              value: "dashboard",
              title: "Dashboard",
              disabled: false,
            },
            {
              icon: "mdi-file-document",
              value: "history",
              title: "Seguimiento de facturas",
              disabled: false,
            },
            {
              icon: "mdi-forward",
              value: "activeForwards",
              title: "Forwards activos",
              disabled: false,
            },
          ],
        },
        {
          icon: "mdi-history",
          value: "history",
          title: "Historial",
          items: [
            {
              icon: "mdi-file-document",
              value: "exchangeRate",
              title: "Historial de conversiones",
              disabled: true,
            },
            {
              icon: "mdi-file-document",
              value: "history",
              title: "Historial de pagos",
              disabled: false,
            },
          ],
        },
        {
          icon: "mdi-wallet",
          value: "wallets",
          title: "Wallets",
          items: [
            {
              icon: "mdi-account-group",
              value: "suppliers",
              title: "Proveedores",
              disabled: true,
            },
            {
              icon: "mdi-account-group",
              value: "suppliers",
              title: "Estado de cuenta",
              disabled: true,
            },
          ],
        },
      ],
      miniVariant: true,
      expandOnHover: false,
      registerFields: [
        { model: "sBankName", type: "text", label: "sBankName" },
        { model: "sAccountNumber", type: "text", label: "sAccountNumber" },
        { model: "sRoutingNumber", type: "text", label: "sRoutingNumber" },
      ],
      transactions: [],
      conversion: {},
      invoices: [],
      invoice: {},
      sAccountNumber: null,
      sPaymentRecipientId: "",
      sTransactionId: "",
      selected: [],
      paymentError: false,
      contact: {},
      supplier: {},
      loadingPayment: false,
      dialogSendPay: false,
      amounts: { USD: 0, MXN: 0 },
      isLoadingRate: false,
      selectedCurrency: null,
      currencyMap: {
        1: { name: "Dólares Estadounidenses", flag: require("@/assets/images/Flags_usa.svg") },
        USD: { name: "Dólares Estadounidenses", flag: require("@/assets/images/Flags_usa.svg") },
        MXN: { name: "Pesos Mexicanos", flag: require("@/assets/images/Flags_mex.svg") },
      },
    };
  },
  created() {
  },
  methods: {
    sendVerification(step) {
      this.step = step;
      try {
        DB.get(`${URI}/api/v1/${this.selectLanguage}/authenticator/`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }).then((response) => {
          if(!response.data.success){
            this.mixError(response.data.message, response.status);
          }
        })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          });
        }
        catch(error){
          this.mixError(error.response.data.message, error.response.status);
        }
    },
    async validateOtp() {
    try {
        const payload = {
          sCode: this.otp
        };

      const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/authenticator/verify`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      });

      return response.data.success;
    } catch (error) {
      console.error('Error in validateOtp:', error);
      return false;
      }
    },
    async sendPayment() {
      this.loadingPayment = true;
      this.paymentError = null;
      const isOtpValid = await this.validateOtp();

      if (!isOtpValid) {
        this.loadingPayment = false;
        this.mixError("Invalid code", 400);
        return;
      }
      const payload = {
        dOriginAmount: this.amounts[this.selectedCurrency],
        dDestAmount: this.amounts[this.supplier.sAccountCurrency],
        dOriginCurrency: this.selectedCurrency,
        dDestCurrency: this.supplier.sAccountCurrency,
        comment: this.comment,
        sPaymentRecipientId: this.supplier.sPaymentRecipientId,
        ...(this.sTransactionId ? { sTransactionId: this.sTransactionId } : {}),
      };

      try {
        const response = await DB.post(
          `${URI}/api/v1/${this.selectLanguage}/payments/sendPayment`,
          payload,
          { headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""}}
        );
        this.mixSuccess(response.data.message);
        this.payment = response.data.payment;
        this.paymentError = false;
      } catch (error) {
        this.paymentError = true;
        this.mixError(error.response.data.message, error.response.status);
      } finally {
        this.loadingPayment = false;
      }
    },
    cancel() {
      this.dialogSendPay = false;
      this.dialogSendPayMXN = false;
      this.amountForexMXN = 0;
      this.otp = "";
      this.dialogEditInvoice = false;
      this.haveInvoice = !this.haveInvoice;
      this.comment = null;
      this.loadingTransaction = false;
      this.dialogSendPayOfInvoice = false;
      this.step = "";
      this.e1 = 1;
      this.avaibleInvoices = [];
      this.selected = [];
      this.selectedSupplier = null;
      this.dialogDetailConversion = false;
      this.active = false;
      this.isLoading = false;
      this.selectedSupplier = [];
      this.dialogModalPay = false;
      this.totalUsd = 0;
      this.isDeferredPayment = false;
      this.isPayMxn = false;
      this.itemsSelected = [];
      this.getConversions();
    },
    getConversions() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/transactions/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.avaibleAmount = response.data.avaibleAmount;
          this.avaibleAmountAux = response.data.avaibleAmount;
          this.items = response.data.transactions;
          this.isLoading = false;
          this.balanceMxn = response.data.balance.balanceMxn.balance;
        })
        .catch((error) => {
          // this.isLoading = false;
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    formatMoney: function (value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(formattedNumber);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    getSuppliers() {
      this.isLoadingSuppliers = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/payment-recipient/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      }).then((response) => {
        this.isLoadingSuppliers = false;
        this.suppliers = response.data.paymentRecipients;
        this.suppliers.map((item) => {
          item.sNameAC = item.sName + " - *******" + (item.sAccountNumber ? item.sAccountNumber.slice(-4) : item.accountNumber.slice(-4)) + " - (" + item.sAccountCurrency + ")";
        });
      });
    },
    dataXLSX() {
      try {
        let data = this.items.map((item) => {
          return {
            Id: item.iTrackingId ? item.iTrackingId : "",
            "Fecha de creación": item.created_at ? this.formatDate(item.created_at) : "",
            "Type Transaction": item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3' ? 'Forward' : (item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a' ? 'Forex' : "N/A"),
            "Total amount (USD)": item.dAmount ? parseFloat(item.dAmount) : "",
            "Total amount (MXN)": item.dDesAmount ? parseFloat(item.dDesAmount) : "",
            "Exchange rate": item.dExchangeRate ? item.dExchangeRate : "",
            Invoice: item.invoice ? item.invoice : "",
            "Purchase Date": item.purchaseDate ? item.purchaseDate : "",
            "Currency profit (%)": item.percentProfit ? parseFloat(item.percentProfit) : "",
            "Currency gain (USD)": item.dollarProfit ? parseFloat(item.dollarProfit) : "",
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, this.nameXLSX);
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } catch (error) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
    updateHeaders() {
      this.headersForex = [
        { text: this.texts.conversions.id, value: "iTrackingId", align: "center" },
        { text: this.texts.conversions.transactionDate, value: "created_at", align: "center" },
        { text: this.texts.conversions.typeTransaction, value: "sTransactionType", align: "center" },
        { text: this.texts.conversions.totalAmountUSD, value: "dAmount", align: "center" },
        { text: this.texts.conversions.totalAmountMXN, value: "dDesAmount", align: "center" },
        { text: this.texts.conversions.exchangeRate, value: "dExchangeRate", align: "center" },
      ]
    }
  },
  beforeMount() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.getConversions();
    this.updateHeaders();
    this.selectedCurrency = 'MXN';
    this.today = moment().format("YYYY-MM-DD");
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
    formattedTime() {
      const minutes = Math.floor(this.timerCount / 60);
      const seconds = this.timerCount % 60;
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
      }
      this.updateHeaders();
    },
    "editableData.sProvider": function (newValue) {
      this.showCreateProvider = newValue === 0;
    },
  },
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #fff;
  opacity: 1;
  height: 100%;
}
.full-height {
  height: 100vh;
  width: 100%;
  overflow-y: auto;
}
.active {
  background-color: #f0f0f0;
}
/* .active-section .v-list-item__icon {
  color: yellow !important;
  background-color: yellow !important;
}

.active-section .v-list-item__title {
  background-color: yellow !important;
} */

.active-item {
  background-color: #f5f7f9 !important;
}
.button-add {
  background: transparent linear-gradient(258deg, #ffc556 0%, #fffc81 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #283c4d;
  text-transform: initial;
}
.v-tabs-slider {
  background: #193D6E !important;
  height: 3px;
  color: #193D6E !important;
  border-radius: 100px;
}

.card-main {
  width: fit-content;
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
}

.card-content {
  position: absolute;
  top: 19px;
  left: 16px;
}

.circle-content {
  text-align: center;
  color: white;
  margin: auto;
}

.btn-custom {
  color: #193D6E;
}

.card-title {
  color: #302e2e;
  font-size: 16px;
  font-family: montserrat-bold;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
}

.card-info,
.balance-title {
  color: #777777;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
}

.card-mxn {
  width: 200px;
  color: #193D6E; 
  font-size: 24px;
  font-family: Mons;
  font-weight: 700;
  line-height: 36px;
  font-style: normal;
  word-wrap: break-word;
}

.container-width,
.header-container {
  max-width: 1280px;
  margin: auto;
}

.title-medium {
  font-family: "montserrat-semibold";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.headline-medium {
  font-family: "montserrat-semibold";
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
}

.body-large {
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.blocked-amount {
  font-family: "montserrat-regular";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.blocked-amount-2 {
  color: #302e2e;
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
}

.circle-sheet {
  width: 200px;
  height: 200px;
  padding-left: 17px;
  padding-right: 62px;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  position: absolute;
  right: -60px;
  top: -20px;
}

.usd-balance {
  color: #666565;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.content-balance {
  color: #302e2e;
  font-family: "montserrat-medium", sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  padding-top: 10px;
}

.h5 {
  font-family: "montserrat-bold";
  font-size: 24px;
  line-height: 36px;
  text-align: left;
}

.buttonAddFounds {
  text-align: center;
  color: #163969;
  font-size: 16px;
  font-family: "montserrat-semibold";
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;
  word-wrap: break-word;
}

.modalTextAddFounds {
  color: #302e2e;
  font-family: "Montserrat-Regular", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.table th {
  background-color: #f2f2f4;
  /* border: 1px solid #ccc; */
}

@media (max-width: 1150px) {
  .card-title {
    font-size: 14px;
  }

  .card-mxn {
    font-size: 20px;
  }

  .usd-balance {
    font-size: 12px;
  }

  .content-balance {
    font-size: 18px;
  }

  .blocked-amount {
    font-size: 12px;
  }

  .blocked-amount-2 {
    font-size: 14px;
  }

  .buttonAddFounds {
    font-size: 14px;
  }

  .circle-sheet {
    display: none;
  }
}

@media (max-width: 1250px) {
  .circle-sheet {
    width: 155px;
    height: 170px;
    padding-left: 17px;
    padding-right: 40px;
    right: -50px;
    top: -5px;
  }
}

.info-card {
  background-color: white;
  border-radius: 20px;
  padding: 16px;
}

.info-block {
  background-color: #F2F2F2;
  border-radius: 10px;
  padding: 8px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.label {
  color: #737583;
  font-family: "montserrat-bold";
  font-size: 14px;
  margin-bottom: 2px;
  padding: 5px;
  width: fit-content;
}

.value {
  color: black;
  font-family: "montserrat-bold";
  font-size: 16px;
  padding: 5px;
  margin-bottom: 5px;
  width: fit-content;
  text-align: right;
}
</style>
